import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import { alertActions } from '../../../../store/actions'
import moment from 'moment'
import { commons } from '../../../../hook/common'

const CertboxAddDoc = (props) => {
  const [checkedaddbox, setCheckedaddbox] = useState(new Set())
  const checkedaddboxRef = useRef(checkedaddbox)
  const [crtDvList, setCrtDvList] = useState([])
  const [crtStsCdList, setCrtStsCdList] = useState([])
  const [docInList, setDocInList] = useState([])
  const [docOutList, setDocOutList] = useState([])
  const [docList, setDocList] = useState([])
  const [showEdit, setShowEdit] = useState() //퍼블리싱임시: 체크선택시 옵션기능보여줌 06.23

  useEffect(() => {
    if (!props.commoncode) return
    if (props.commoncode?.co.CRT_DV) {
      setCrtDvList(props.commoncode?.co.CRT_DV)
    }

    if (props.commoncode?.co.CRT_STS_CD) {
      setCrtStsCdList(props.commoncode?.co.CRT_STS_CD)
    }
  }, [props.commoncode])

  useEffect(() => {
    if (props.certboxIn) {
      let docTempList = []
      let docTempInfo = {}
      for (let cont of props.certboxIn) {
        if (cont.sts === '03' || cont.sts === '10' || cont.sts === '12') {
          docTempInfo = {
            crtCd: cont.crtCd,
            sts: cont.sts,
            issuedt: cont.issuedt,
            docid: cont.docid,
            prchsNm: cont.prchsNm,
            fileGroupId: cont.fileGroupId,
            crtRcvSeq: cont.crtRcvSeq,
            crtSeq: cont.crtSeq,
          }
          docTempList.push(docTempInfo)
        }
      }
      setDocInList(docTempList)
    } else {
    }
  }, [props.certboxIn])

  useEffect(() => {
    if (props.certboxOut) {
      let docTempList = []
      let docTempInfo = {}
      for (let cont of props.certboxOut) {
        if (cont.sts === '03' || cont.sts === '10' || cont.sts === '12') {
          docTempInfo = {
            crtCd: cont.crtCd,
            sts: cont.sts,
            issuedt: cont.issuedt,
            docid: cont.docid,
            prchsNm: cont.prchsNm,
            fileGroupId: cont.fileGroupId,
            crtRcvSeq: cont.crtRcvSeq,
            crtSeq: cont.crtSeq,
          }
          docTempList.push(docTempInfo)
        }
      }
      setDocOutList(docTempList)
    }
  }, [props.certboxOut])

  useEffect(() => {
    let docTemp1List = docInList
    let docTemp2List = docOutList
    let removeOverLapArr1 = []
    docTemp2List.forEach((item) => {
      const crtSeq = item.crtSeq
      let ExistenceStatus = docTemp1List.findIndex((i) => i.crtSeq === crtSeq)
      if (ExistenceStatus === -1) {
        removeOverLapArr1.push(item)
      }
    })
    // 제출할 파일이 있는 경우에만 출력
    const list = removeOverLapArr1?.filter((item) => !item.fileGroupId === false)
    setDocList(list)
    console.log('docList', list)
  }, [docOutList])

  //console.log('props.certboxIn = ', props.certboxIn);

  const makeCrtCd = (crtCd) => {
    const list = crtDvList?.find((crtDv) => crtDv?.cd === crtCd)

    return list ? '[' + list.cdName + ']' : ''
  }

  const makeCrtStsCd = (sts) => {
    const list = crtStsCdList?.find((crtSts) => crtSts.cd === sts)

    return list ? list.cdName : ''
  }

  const checkedaddItemHandler = (id, isChecked, crtSeq, sts, crtRcvSeq, obj) => {
    if (isChecked) {
      checkedaddboxRef.current.add(obj)
    } else {
      for (let cont of checkedaddboxRef.current) {
        if (obj === cont) {
          checkedaddboxRef.current.delete(cont)
        }
      }
    }
    setCheckedaddbox(checkedaddboxRef.current)
    changeaddShowForm()
  }

  const checkaddHandler = ({ target }, certbox) => {
    checkedaddItemHandler(target.id, target.checked, certbox.crtSeq, certbox.sts, certbox.crtRcvSeq, certbox)
  }

  //복수 제어 함수
  const changeaddShowForm = () => {
    setShowEdit(checkedaddboxRef.current.size)
  }

  let style = {
    backgroundColor: 'rgb(0, 0, 0)',
    position: 'fixed',
    inset: '0px',
    opacity: '0.6',
    zIndex: '111',
  }

  let styleModal = {
    position: 'absolute',
    opacity: '1',
    zIndex: '112',
    display: 'block',
    height: '500px'
  }

  let styleDiv = {
    maxHeight: 'calc(50vh - 7rem)',
  }

  const handleClose = () => {
    props.onClose()
  }

  const docAdd = () => {
    //console.log("setState2 = ", state);
    props.onDocAdd(Array.from(checkedaddboxRef.current))
    props.onClose()
  }

  return (
    <>
      <div style={style}></div>
      <div style={styleModal} id="document-register" className="modal w1120">
        <div className="modal-head">
          <h3 className="h3-tit first">선택한 증명서</h3>
        </div>
        <div className="btn-block center">
          <a href="#" className="btn-primary md" onClick={docAdd}>
            증명서 추가
          </a>
        </div>
        <div className="modal-cont mobile-scroll" style={styleDiv}>
          <table className="tbl-list">
            <caption>선택, 증명서 및 상태, 발급일시, 발급번호, 발급처 항목으로 구성</caption>
            <colgroup>
              <col style={{ width: '6%' }} />
              <col style={{ width: '22%' }} />
              <col style={{ width: '24%' }} />
              <col style={{ width: '24%' }} />
              <col style={{ width: '24%' }} />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">선택</th>
                <th scope="col">증명서 및 상태</th>
                <th scope="col">발급일시</th>
                <th scope="col">발급번호</th>
                <th scope="col">발급처</th>
              </tr>
            </thead>
            <tbody>
              {docList?.length > 0 ? (
                docList?.map(
                  (certboxInfo, index) =>
                    (certboxInfo.sts === '03' || certboxInfo.sts === '10' || certboxInfo.sts === '12')  && (
                      <tr key={index}>
                        <td>
                          <input
                            type="checkbox"
                            id={`${'rowadd-' + certboxInfo.crtSeq + index}`}
                            onChange={(e) => checkaddHandler(e, certboxInfo)}
                            checked={checkedaddboxRef.current.has(certboxInfo)}
                          />
                          <em></em>
                        </td>
                        <td className="cell" data-title={'증명서 및 상태'}>
                          {makeCrtCd(certboxInfo.crtCd)} - {makeCrtStsCd(certboxInfo.sts)}
                        </td>
                        <td className="cell" data-title={'발급일시'}>
                          {moment(certboxInfo.issuedt, 'YYYYMMDDhhmmss').format('YYYY.MM.DD HH:mm:ss')}
                        </td>
                        <td className="cell" data-title={'발급번호'}>
                          {certboxInfo.docid}
                        </td>
                        <td className="cell" data-title={'발급처'}>
                          {certboxInfo.prchsNm}
                        </td>
                      </tr>
                    ),
                )
              ) : (
                <tr>
                  <td colSpan={5}>
                    <div className="nodata">등록된 자료가 없습니다.</div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="btn-block center">
            <a href="#" className="btn-primary md" onClick={docAdd}>
              증명서 추가
            </a>
          </div>
        </div>
        <button type="button" className="modal-close b-close" onClick={handleClose}>
          창닫기
        </button>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {}
}

const actionCreators = {
  error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(CertboxAddDoc)
